package com.essntl.uikit.components.expandable

import androidx.compose.foundation.layout.*
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.TransformOrigin
import androidx.compose.ui.graphics.graphicsLayer
import com.essntl.uikit.components.iconbutton.flat.EsLargeFlatIconButton
import com.essntl.uikit.components.icons.EsIcons
import com.essntl.uikit.components.icons.EsLargeIcon
import com.essntl.uikit.components.utils.spacing
import com.essntl.uikit.theme.esColorScheme
import com.essntl.uikit.theme.esTypography

@Composable
fun ExpandableCardHeader(
    title: String,
    iconRes: String? = null,
    rowContent: @Composable RowScope.() -> Unit = {},
    isExpanded: Boolean,
    onClick: () -> Unit,
) {
    Row(
        verticalAlignment = Alignment.CenterVertically,
        horizontalArrangement = Arrangement.SpaceBetween,
        modifier = Modifier.fillMaxWidth(),
    ) {
        Row(
            verticalAlignment = Alignment.CenterVertically,
            horizontalArrangement = Arrangement.Center,
        ) {
            iconRes?.let {
                EsLargeIcon(
                    res = it,
                    tint = MaterialTheme.esColorScheme.iconPrimary,
                )
                Spacer(modifier = Modifier.width(1.5.spacing))
            }

            Text(
                text = title,
                style = MaterialTheme.esTypography.h4SemiBold20,
            )

            rowContent()
        }

        Row(
            horizontalArrangement = Arrangement.spacedBy(.5.spacing),
        ) {
            EsLargeFlatIconButton(
                onClick = onClick,
                iconRes = EsIcons.ArrowDown,
                modifier = Modifier
                    .graphicsLayer {
                        transformOrigin = TransformOrigin.Center
                        rotationZ = if (isExpanded) 180f else 0f
                    },
            )
        }
    }
}